import { useMatches, useNavigate } from 'react-router-dom';

export const useLeaveEntityPage = () => {
  const matches = useMatches();
  const navigate = useNavigate();

  return () => {
    const onEntityPage = matches.some((match) => Object.values(match.params).some(Boolean));
    if (onEntityPage) navigate('/dashboard', { replace: true });
  };
};
